import React, { FC, useMemo } from 'react'
import { membershipStateContext } from './Context'
import { MembershipContext, State } from './types'

type Props = {
  membershipInformation: MembershipContext | null
}

export const MembershipProvider: FC<React.PropsWithChildren<Props>> = ({
  children,
  membershipInformation,
}) => {
  const value = useMemo<State>(
    () => ({
      membershipInformation,
    }),
    [membershipInformation],
  )
  return (
    <membershipStateContext.Provider value={value}>
      {children}
    </membershipStateContext.Provider>
  )
}
